import type { IsoDateTime, IsoDateTimeTz, IsoTime, IsoTimeTz } from '../../types/iso-date';
import { deconstructDate } from '../helper/deconstruct-date.function';

/**
 * Extracts the hour (0-23) from an ISO 8601 date-time or time string.
 *
 * Supported inputs:
 * - Date-time (no tz): YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?
 * - Date-time with tz: YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?(Z|±HH:MM)
 * - Time-only (no tz): HH:mm:ss(.fraction[1-6])?
 * - Time-only with tz: HH:mm:ss(.fraction[1-6])?(Z|±HH:MM)
 *
 * Returns the numeric hour (0-23).
 * Throws if the input is not a valid ISO time/date-time in one of the above forms.
 */
export function getHour<T extends  IsoDateTime | IsoDateTimeTz | IsoTime | IsoTimeTz>(input: T): number {
  const { hours } = deconstructDate(input);
  if(hours === undefined)
    throw new Error('getHour: invalid ISO time/date-time string');
  return Number(hours);
}

